import React, { useState } from "react";
import { ethers } from "ethers";

export function Withdrawal({ withdrawToken, tokenSymbol, max }) {
  const [amount, setAmount] = useState("");

  const handleChange = (event) => {
    setAmount(event.target.value);
  };

  const handleClick = (event) => {
    event.preventDefault();

    // 👇️ value of input field
    console.log("old value: ", amount);

    // 👇️ set value of input field
    setAmount(max);
  };

  return (
    <div className="qte-form">
      <form
        onSubmit={(event) => {
          // This function just calls the transferTokens callback with the
          // form's data.
          event.preventDefault();

          const formData = new FormData(event.target);
          const val = formData.get("amount");
          //reformat val to wei
          const amount = ethers.utils.parseEther(val);
          withdrawToken(amount);
          // if (amount) {
          //   withdrawToken(amount);
          // }
        }}
      >
        <div className="form-group input-group mb-2">
          <input
            className="form-control qte-forms"
            id="amount"
            type="text"
            name="amount"
            required
            onChange={handleChange}
            value={amount}
          />
          <span onClick={handleClick} className="input-group-text text-right">
            max
          </span>
        </div>
        <div className="form-group">
          <input
            className="default-btn default-btn--small"
            type="submit"
            value="Withdraw"
          />
        </div>
      </form>
    </div>
  );
}
